import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "@vilocnv/allsetra-core";
import { getObjectDataForMap } from "domain/objects/api/get-object-data-for-map";
import { ObjectForMapRequestDto } from "domain/objects/entities/dtos/object-for-map-request.dto";

const getObjectDataForMapAction = createAsyncThunk(
  "objects/v2/getObjectDataForMapAction",
  async (payload: ObjectForMapRequestDto) => {
    try {
      const data = await getObjectDataForMap(payload);
      const { objectId } = payload;

      return { ...data, uniqueId: objectId };
    } catch (e: any) {
      toast.error(e.message);
      throw new Error(e);
    }
  }
);

export default getObjectDataForMapAction;
